import classNames from "classnames";
import { STATUS, PAGE_STATUS, BADGE_VARIANTS } from "../../../constants";
import { capitalizeFirstLetterOfWord } from "../../../helpers";

const { DANGER, PRIMARY, SECONDARY, SUCCESS, WARNING } = BADGE_VARIANTS;
const { ACTIVE, ARCHIVED, SUSPENDED, INACTIVE, FAILURE, IN_PROGRESS } = STATUS;
const { DRAFT, PUBLISHED } = PAGE_STATUS;
const UNDER_SCORE = "_";
const BLANK_SPACE = " ";

const Badge = ({ value, size, color, classes, shouldFormat = true }) => (
  <div
    className={classNames(
      `rounded-xl h-5 px-3 inline-flex items-center ${classes}`,
      {
        "text-emerald-800 bg-emerald-100":
          value === ACTIVE ||
          value === PUBLISHED ||
          color === SUCCESS ||
          value === SUCCESS,
        "text-red-800 bg-red-100":
          value === ARCHIVED ||
          color === DANGER ||
          value === INACTIVE ||
          value === FAILURE,
        "text-amber-800  bg-amber-100":
          value === SUSPENDED || color === WARNING || value === IN_PROGRESS,
        " text-indigo-800 bg-indigo-100": color === PRIMARY,
        "text-gray-800 bg-gray-100": color === SECONDARY || value === DRAFT,
        "text-xs": size === "xs",
        "text-sm": size === "sm",
        "text-base": size === "md",
        "text-lg": size === "lg",
      }
    )}
  >
    <span className="font-medium w-max">
      {shouldFormat
        ? capitalizeFirstLetterOfWord(value)?.replace(UNDER_SCORE, BLANK_SPACE)
        : value}
    </span>
  </div>
);

export default Badge;
